var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3988 9.3575L12.4081 4.36625C12.1736 4.13187 11.8556 4.00021 11.5241 4.00021C11.1925 4.00021 10.8745 4.13187 10.64 4.36625L7.29125 7.715L4.625 0.25H3.375L0.25 9H1.5L2.12438 7.125H5.87437L6.37625 8.63L1.86625 13.14C1.75012 13.2561 1.658 13.3939 1.59515 13.5456C1.5323 13.6973 1.49995 13.8599 1.49995 14.0241C1.49995 14.1883 1.5323 14.3508 1.59515 14.5025C1.658 14.6542 1.75012 14.792 1.86625 14.9081L4.7075 17.75H10.7013L17.3988 11.0519C17.5101 10.9406 17.5984 10.8085 17.6587 10.6631C17.719 10.5177 17.75 10.3618 17.75 10.2044C17.75 10.047 17.719 9.8911 17.6587 9.74568C17.5984 9.60026 17.5101 9.46814 17.3988 9.35687V9.3575ZM2.54063 5.875L3.9975 1.5L5.4575 5.875H2.54063ZM10.1844 16.5H5.225L2.75 14.0238L6.695 10.0794L11.65 15.0337L10.1844 16.5ZM12.5344 14.15L7.57938 9.19563L11.5244 5.25L16.4788 10.2044L12.5344 14.15Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanEditorIcon);
export default __webpack_public_path__ + "static/media/clean-editor-icon.4e7e803f20b23bf4961f3e6550804746.svg";
export { ForwardRef as ReactComponent };